export default __webpack_public_path__ + "static/media/IMG_0822.fa3804e3.fa3804e3.JPG";